@if (view(); as v) {
  <div class="whisp-debug" data-testid="whisp-debug-panel">
    <div class="title">Whisp-Debug</div>
    <table class="meta">
      <tr>
        <th>status</th>
        <td>
          {{ v.status }}
          @if (!v.current) {
            <b class="stale">(stale)</b>
          }
        </td>
      </tr>
      <tr>
        <th>whispVersion</th>
        <td>{{ v.whispVersion }}</td>
      </tr>
      <tr>
        <th>checkedAt</th>
        <td>{{ v.checkedAt }}</td>
      </tr>
      <tr>
        <th>whispGeoHash</th>
        <td class="hash">{{ v.whispGeoHash }}</td>
      </tr>
      <tr>
        <th>derivation</th>
        <td>{{ v.whispDerivationVersion }}</td>
      </tr>
      <tr>
        <th>findingId</th>
        <td class="hash">{{ v.findingId }}</td>
      </tr>
    </table>

    <details open>
      <summary>Calls ({{ v.calls?.length ?? 'n/a' }})</summary>
      @for (call of v.calls ?? []; track call.callId; let i = $index) {
        <div class="call" data-testid="whisp-debug-call">
          <b>#{{ i + 1 }}</b>
          {{ call.status }} · {{ call.polygonCount }} polygons · {{ call.byteSize | number }} B · attempts {{ call.attempts }}
          @if (call.errorCode) {
            <span class="stale">{{ call.errorCode }}</span>
          }
          <div class="sub">queued {{ call.queuedAt }} · submitted {{ call.submittedAt }} · finished {{ call.finishedAt }}</div>
          <div class="sub">own: {{ call.ownPartIds.join(', ') }}</div>
          @for (other of call.otherJobs; track $index) {
            <div class="sub">other job · {{ other.env }} · {{ other.partCount }} parts</div>
          }
        </div>
      } @empty {
        <div class="sub">no call data stored for this finding</div>
      }
    </details>

    <details open>
      <summary>Groups → parts</summary>
      @for (row of groups(); track row.group.groupId) {
        <div class="group">
          <b>{{ row.group.groupId < 0 ? 'not sent' : 'G' + row.group.groupId }}</b>
          {{ row.group.grade }}
          @if (row.group.areaHa != null) {
            · {{ row.group.areaHa | number: '1.0-2' }} ha
          }
        </div>
        @for (partRow of row.parts; track partRow.part.partId) {
          <button
            type="button"
            class="part"
            data-testid="whisp-debug-part"
            [class.selected]="partRow.part.partId === selectedPartId()"
            (click)="selectPart.emit(partRow.part.partId)"
          >
            <span class="dot" [style.background]="partRow.color"></span>
            {{ partRow.part.partId }} · {{ partRow.part.riskTimber ?? partRow.part.errorCode ?? 'error' }}
            @if (partRow.part.areaHa != null) {
              · {{ partRow.part.areaHa | number: '1.0-2' }} ha
            }
          </button>
        }
      }
    </details>

    @if (selected(); as s) {
      <div class="detail" data-testid="whisp-debug-detail">
        <div class="title">Part {{ s.part.partId }}</div>
        <table class="meta">
          <tr>
            <th>sourceFeature/Part</th>
            <td>{{ s.part.sourceFeature }} / {{ s.part.sourcePart }}</td>
          </tr>
          <tr>
            <th>area</th>
            <td>
              {{ s.part.areaHa | number: '1.0-4' }} ha
              @if (s.point) {
                (point sent as circle)
              }
            </td>
          </tr>
          <tr>
            <th>call</th>
            <td>{{ s.call > 0 ? '#' + s.call : 'n/a' }}</td>
          </tr>
          <tr>
            <th>risk_timber</th>
            <td [style.color]="colorOf(s.part.riskTimber)">
              <b>{{ s.part.riskTimber ?? s.part.errorCode ?? 'error' }}</b>
            </td>
          </tr>
          <tr>
            <th>risk_pcrop</th>
            <td>{{ s.riskPcrop }}</td>
          </tr>
          <tr>
            <th>risk_acrop</th>
            <td>{{ s.riskAcrop }}</td>
          </tr>
          <tr>
            <th>Whisp rule</th>
            <td data-testid="whisp-debug-step" [class.stale]="s.stepMismatch">
              step {{ s.step.step }}: {{ s.step.rule }} → {{ s.step.risk }}
            </td>
          </tr>
          <tr>
            <th>Claudia tree</th>
            <td data-testid="whisp-debug-tree" [class.stale]="s.treeMismatch">→ {{ s.tree.risk }}</td>
          </tr>
        </table>
        <ol class="tree">
          @for (node of s.tree.nodes; track node.question) {
            <li>{{ node.question }}: {{ node.answer ? 'ja' : 'nein' }}</li>
          }
        </ol>
        <table class="meta">
          @for (indicator of s.indicators; track indicator.key) {
            <tr [class.on]="indicator.on">
              <th [title]="indicator.label">{{ indicator.key }}</th>
              <td>{{ indicator.on === true ? 'yes' : indicator.on === false ? 'no' : '–' }}</td>
            </tr>
          }
          @for (entry of s.keyHa; track entry[0]) {
            <tr>
              <th>{{ entry[0] }}</th>
              <td>{{ entry[1] | number: '1.0-4' }} ha</td>
            </tr>
          }
        </table>
        <details>
          <summary>Raw Whisp row ({{ s.rawRow.length }})</summary>
          <table class="meta raw">
            @for (cell of s.rawRow; track cell.key) {
              <tr>
                <th>{{ cell.key }}</th>
                <td>{{ cell.value }}</td>
              </tr>
            }
          </table>
        </details>
      </div>
    }
  </div>
}
